import React, { useState, useCallback, memo, useEffect } from 'react';

import { EVENTS, trackEvent } from '@app/segment';

import useMobileNavOpen from '@app/shell/SiteHeader/shared/hooks/useMobileNavOpen';
import Container from '@app/shell/SiteHeader/shared/components/MobileMenu/Container';
import MainMenu from '@app/shell/SiteHeader/shared/components/MobileMenu/MainMenu';
import SubMenu from '@app/shell/SiteHeader/shared/components/MobileMenu/SubMenu';

const MobileNav = () => {
  const { isOpen, handleToggle } = useMobileNavOpen();

  useEffect(() => {
    const htmlTag = document.querySelector('html');

    if (isOpen) {
      htmlTag?.classList.add('is-locked');
    } else {
      htmlTag?.classList.remove('is-locked');
    }
  }, [isOpen]);

  const [activeSubMenu, setSubMenuClick] = useState(null);

  const handleSubMenuClick = useCallback(
    (event) => {
      trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
        label: event.title,
      });
      setSubMenuClick(event);
    },
    [setSubMenuClick],
  );

  const handleSubMenuCloseClick = useCallback(() => {
    setSubMenuClick(null);
    setTimeout(() => setSubMenuClick(null), 300);
  }, [setSubMenuClick]);

  const handleHeaderOnClick = useCallback(() => {
    if (activeSubMenu) {
      setSubMenuClick(null);
      setSubMenuVisibility(false);
    } else {
      handleToggle();
    }
  }, [activeSubMenu, handleToggle]);

  const [isSubMenuVisible, setSubMenuVisibility] = useState(false);

  return (
    <Container
      isOpen={isOpen}
      hasActiveSubmenu={isSubMenuVisible}
      handleHeaderOnClick={handleHeaderOnClick}
    >
      <MainMenu
        isOpen={!isSubMenuVisible}
        handleItemOnClick={(props) => {
          handleSubMenuClick(props);
          setSubMenuVisibility(true);
        }}
      />

      <SubMenu
        isOpen={isSubMenuVisible}
        activeSubMenu={activeSubMenu}
        handleOnClose={() => {
          handleSubMenuCloseClick();
          setSubMenuVisibility(false);
        }}
        handleItemOnClick={(props) => {
          handleSubMenuClick(props);
          setSubMenuVisibility(true);
        }}
      />
    </Container>
  );
};

export default memo(MobileNav);
